export interface FileLikePath {
  path: string;
}

export const getFileUrl = (file: FileLikePath | null | undefined): string => {
  if (!file?.path) return "";
  const apiBase = process?.env?.NEXT_PUBLIC_API_IMAGE_URL ?? "";

  return file.path.startsWith("/") ? `${apiBase}${file.path}` : file.path;
};
